var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01176 0.16124C0.954506 0.109735 0.887162 0.0694698 0.813568 0.042743C0.739974 0.0160161 0.661572 0.00335108 0.582837 0.00547159C0.504102 0.0075921 0.426576 0.0244564 0.354687 0.0551015C0.282798 0.0857465 0.217952 0.129572 0.163853 0.184076C0.109754 0.23858 0.0674606 0.302696 0.0393878 0.372761C0.0113149 0.442827 -0.00198768 0.51747 0.000239624 0.59243C0.00246693 0.66739 0.0201804 0.741198 0.0523688 0.809641C0.0845571 0.878083 0.13059 0.93982 0.187839 0.991325L5.58467 5.84395C5.69601 5.94416 5.84341 6 5.99663 6C6.14985 6 6.29725 5.94416 6.40859 5.84395L11.806 0.991324C11.8645 0.940159 11.9118 0.878436 11.945 0.809742C11.9782 0.741048 11.9968 0.666752 11.9996 0.591168C12.0024 0.515584 11.9895 0.44022 11.9614 0.369454C11.9334 0.298687 11.8909 0.233928 11.8363 0.178939C11.7818 0.12395 11.7163 0.0798266 11.6437 0.0491316C11.5711 0.0184367 11.4928 0.00178224 11.4134 0.000135509C11.334 -0.00151122 11.255 0.0118824 11.1811 0.039539C11.1071 0.0671955 11.0397 0.108564 10.9827 0.16124L5.99663 4.64392L1.01176 0.16124Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ad5ed7c3c65f50670abf2e3bdc2c499f.svg";
export { ForwardRef as ReactComponent };